import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 w-full" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-center sm:gap-5 w-full sm:w-auto" }
const _hoisted_4 = { class: "text-lg sm:text-xl font-semibold break-words" }
const _hoisted_5 = {
  key: 0,
  class: "hidden sm:inline px-2 py-1 bg-green-500 text-white rounded-lg border text-xs"
}
const _hoisted_6 = {
  key: 1,
  id: "tips",
  class: "group flex justify-start"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle cursor-pointer text-white bg-h-warning-400 px-1 text-xl rounded-full hover:scale-75 transition-all animate-bounce-short" }, null, -1)
const _hoisted_8 = { class: "hidden absolute transition-all group-hover:flex group-focus:flex bg-white p-3 w-64 mt-8 rounded-lg z-50 shadow-md border overflow-hidden break-words whitespace-normal" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "flex sm:hidden items-center justify-between gap-2 mt-1" }
const _hoisted_11 = {
  key: 0,
  class: "px-2 py-1 bg-green-500 text-white rounded-lg border text-xs"
}
const _hoisted_12 = { class: "flex gap-2 ml-auto" }
const _hoisted_13 = { class: "hidden sm:flex gap-2" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "flex items-center gap-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle !text-3xl text-h-warning-400" }, null, -1)
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_VideoComponent = _resolveComponent("VideoComponent")!
  const _component_Image = _resolveComponent("Image")!
  const _component_PDFComponent = _resolveComponent("PDFComponent")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", null, [
      (_ctx.loaderStore.load[_ctx.ELoader.MATERIAL])
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            loader: _ctx.loaderStore.load[_ctx.ELoader.MATERIAL]
          }, null, 8, ["loader"]))
        : (_ctx.storeMaterial.currentMaterial?.file)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
              _createElementVNode("header", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.storeMaterial.currentMaterial.name), 1),
                  (_ctx.isDone)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString("Concluído")))
                    : _createCommentVNode("", true),
                  (!_ctx.isDone && _ctx.storeMaterial.isVideo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("p", { innerHTML: 
                  'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
                 }, null, 8, _hoisted_9)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.isDone)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString("Concluído")))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Button, {
                      icon: "pi pi-chevron-left",
                      class: "btn-primary",
                      onClick: _withModifiers(_ctx.storeNavigation.prev, ["prevent"])
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_Button, {
                      icon: "pi pi-chevron-right",
                      class: "btn-primary",
                      disabled: _ctx.storeNavigation.isNextDisabled,
                      onClick: _withModifiers(_ctx.storeNavigation.next, ["prevent"])
                    }, null, 8, ["disabled", "onClick"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-chevron-left",
                    class: "btn-primary",
                    disabled: _ctx.isPrevThrottled,
                    onClick: _withModifiers(_ctx.handlePrev, ["prevent"])
                  }, null, 8, ["disabled", "onClick"]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-chevron-right",
                    class: "btn-primary",
                    disabled: _ctx.storeNavigation.isNextDisabled || _ctx.isNextThrottled,
                    onClick: _withModifiers(_ctx.handleNext, ["prevent"])
                  }, null, 8, ["disabled", "onClick"])
                ])
              ]),
              (_ctx.storeMaterial.isVideo)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`${_ctx.flex} mt-4 flex-col z-10`)
                  }, [
                    _createVNode(_component_VideoComponent, {
                      data: _ctx.storeMaterial.currentMaterial?.file,
                      idVideo: _ctx.storeMaterial.currentMaterial?.file?.id,
                      startTime: _ctx.time,
                      isAdaptativeLearning: false,
                      ref: "videoComponent"
                    }, null, 8, ["data", "idVideo", "startTime"])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.storeMaterial.isImage)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(`${_ctx.flex} mt-4`)
                  }, [
                    _createVNode(_component_Image, {
                      src: _ctx.storeMaterial.currentMaterial?.file?.url,
                      alt: "material-image",
                      imageClass: "w-full h-[100%] sm:h-[600px] lg:h-[600px] object-cover",
                      preview: ""
                    }, null, 8, ["src"])
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.storeMaterial.isAudio)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(`${_ctx.flex} mt-4`)
                  }, [
                    _createElementVNode("audio", {
                      id: "material-audio",
                      src: _ctx.storeMaterial.currentMaterial?.file?.url,
                      class: "w-full h-[100%] sm:h-[600px] lg:h-[600px]"
                    }, null, 8, _hoisted_14)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.storeMaterial.isPdf)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: _normalizeClass(`${_ctx.flex} mt-4`)
                  }, [
                    _createVNode(_component_PDFComponent, {
                      url: _ctx.storeMaterial.currentMaterial?.file?.url
                    }, null, 8, ["url"])
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showAlert,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showAlert) = $event)),
      draggable: false,
      breakpoints: { '960px': '95vw', '640px': '95vw' },
      style: { width: '25vw', minWidth: '360px' },
      modal: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("section", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("labels.generic", { pt: `Alerta`, en: `Alert` })), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", {
          class: "text-xl",
          innerHTML: 
        'O material do tipo <b>vídeo só será considerado concluído</b>, se o aluno <b>assistir pelo menos 90%</b> de seu conteúdo.'
      
        }, null, 8, _hoisted_17)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}